// @flow weak

// !!! IMPORTANT !!!
//
// This file is shared between the zapier/zapier and zapier/next-js repository.
// Any changes made here should be reflected in there as well.
// For more information, see: https://zapier.quip.com/xaKqAOpdhpY2#ZXFACA8Jnp9
import React from 'react';

import { buildCommonComponent } from '@zapier/legacy-components';

import 'app/common/components/Heading.scss';

const buildHeading = buildCommonComponent('generic-heading');

export const Heading1 = buildHeading(null, 'h1');
export const Heading2 = buildHeading(null, 'h2');
export const Heading3 = buildHeading(null, 'h3');
export const Heading4 = buildHeading(null, 'h4');

export const SectionHeading = ({ kind, ...props }) => (
  <Heading2 kind={['bold 20 1-em-bottom flex', kind]} {...props}>
    {props.children}
  </Heading2>
);
